import { authHttp } from '../http'
import { errorHandler } from '../../../util/error.service'
import { urlValidacaoEtiquetaIdentificadorVolumes } from '../../routes/picking.routes'

export async function validarEtiquetaIdentificadorVolumes(picking_id, area_ids) {
  try {
    const url = urlValidacaoEtiquetaIdentificadorVolumes(picking_id, area_ids)
    const response = await authHttp().get(url)
    return response.data.erros || []
  } catch (error) {
    throw errorHandler(error)
  }
}
